// Orders filters
const getDefaultState = () => {
	return {
		filters: {
			query: "",
			selectedClassSubclasses: [],
			brokerIds: [],
			entityIds: [],
			businessType: "",
			period: [],
			sortBy: "date_inception", // For policies
			mtaSortBy: "date_effective", // For MTAs
			statusFilters: {
				// Policy statuses
				pending: false,
				initialised: true,
				documents: true,
				processed: true,
				cancelled: false,
			},
			mtaTypeFilters: {
				additionalPremium: true,
				refund: true,
				cancellation: true,
			},
			currentPage: 0,
			mtaCurrentPage: 0,
			activeMode: "policies",
		},
	}
}

export const state = () => getDefaultState()

export const mutations = {
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_FILTER(state, { filterName, value }) {
		state.filters[filterName] = value
	},
}

export const actions = {
	reset({ commit }) {
		commit("RESET_STATE")
	},
	updateFilter({ commit }, { filterName, value }) {
		commit("SET_FILTER", { filterName, value })
	},
}

export const getters = {
	getFilters(state) {
		return state.filters
	},
	getFilter: (state) => (filterName) => {
		return state.filters[filterName]
	},
}
